export default {
  data() {
    return {
      viewportWidth: 0,
    }
  },
  mounted() {
    this.updateViewportWidth()
    this.screeResizeHandler()
  },
  methods: {
    screeResizeHandler() {
      window.addEventListener('resize', () => {
        this.updateViewportWidth()
      })
    },
    updateViewportWidth() {
      this.viewportWidth = window.innerWidth
    },
  },
}
